<template>
    <div
        v-if="variant !== 2 || [223,66].indexOf(user.currentCourseId) === -1"
        id="home-goals"
    >
        <h2 style="padding-top: 26px;">Your goals
            <f7-link
                href="/onboarding/goals?fromHome=1"
                style="float: right; font-size: 15px; font-family: AndesLight; color: #EFC6AB; line-height: 33px"
            >Explore more goals</f7-link>
        </h2>
        <div style="margin: 0 -16px -16px;">
            <f7-swiper
                v-if="myTopics && myTopics.length && shownTopics"
                ref="swiper"
                :params="{slidesOffsetAfter: 16,slidesOffsetBefore: 16, speed:500, slidesPerView: 'auto', spaceBetween: 10, noSwiping: true}"
                :navigation="!isPgap"
            >
                <template v-for="topicId in shownTopics">
                    <f7-swiper-slide
                        v-if="topicsIndex[topicId] && isEligibleForGoal(topicsIndex[topicId])"
                        :key="`slide-${topicId}`"
                        style="width: 120px"
                    >
                        <topic-card
                            :key="topicId"
                            :topic="topicsIndex[topicId]"
                            :on-home="true"
                        />
                    </f7-swiper-slide>
                </template>
            </f7-swiper>
            <f7-link
                v-else
                :animate="false"
                :href="`${onboardingCompleted > 1 ? '/onboarding/goals' :'#'}`"
                reload
                style="border: 2px dashed white; display: block; color: white; font-size: 15px; padding: 16px; margin: 0 16px 18px; border-radius: 16px; text-align: center"
            >
                Ready to improve?<br>Set up your goals!
            </f7-link>
        </div>
    </div>
</template>

<script>
import utils from '../../js/utils';

import TopicCard from '../../components/topicCard.vue';

export default {
    components: {
        TopicCard,
    },
    props: ['variant'],
    store: [
        'api',
        'user',
        'myTopics',
        'topicsIndex',
        'onboardingCompleted',
        'myTraits',
        'progress'],
    data () {
        return {
            mySwiper: null,
            shownTopics: [],
        };
    },
    computed: {
        isPgap: function () {
            return pgap;
        }
    },
    watch: {
        myTopics: function () {
            this.makeShownTopics();
        },
        myTraits: function () {
            this.makeShownTopics();
        },
    },
    mounted: function () {
        this.$f7ready(() => {
            this.init();
        });
        this.init();
    },
    methods: {
        init: function () {
            this.mySwiper = this.$refs.swiper ? this.$refs.swiper.swiper : false;
            this.makeShownTopics();
        },
        makeShownTopics: function () {
            // We should avoid magic numbers and set all such kind of things to variables in order to allow
            // codebase be maintainable and easyreadable
            const onBoardingTopicId = 58;

            Vue.set(this, 'shownTopics', []);
            for (let i = 0; i < this.myTopics.length; i++) {
                const topicId = this.myTopics[i];
                if (this.topicsIndex[topicId] && this.isEligibleForGoal(this.topicsIndex[topicId])) {
                    this.shownTopics.push(topicId);
                }
            }
            // order by recency
            let doneTopics = [];
            for (let i = 0; i < this.progress.length; i++) {
                const p = this.progress[i];
                if (p.type === 'unit' && doneTopics.indexOf(p.topicId) === -1) {
                    doneTopics.push(p.topicId);
                    this.shownTopics.move(this.shownTopics.indexOf(p.topicId), 0);
                }
            }
            // make sure topic 58 (start) is always first
            if (this.onboardingCompleted < 2) {
                if (this.shownTopics.indexOf(onBoardingTopicId) !== 0) {
                    this.shownTopics.splice(this.shownTopics.indexOf(onBoardingTopicId), 1);
                    this.shownTopics.unshift(onBoardingTopicId);
                }
            }

            // make sure topic 58 (start) is removed from Topic list after being completed
            // There's a code in courseComplete.vue which removes it from list of Topics after comletion,
            // but after page reloading or other circumstances - it appears again because it's not
            // handled on a back end, so should be handled here in order to be invisible if it's been completed
            // TODO Should be handled on a back end maybe
            if (this.onboardingCompleted === 2
                && doneTopics.includes(onBoardingTopicId)
                && this.shownTopics.includes(onBoardingTopicId)) {
                const onboardingTopicIndex = this.shownTopics.indexOf(onBoardingTopicId);

                this.shownTopics.splice(onboardingTopicIndex, 1);
            }

            setTimeout(() => {
                if (!this.mySwiper) {
                    this.mySwiper = this.$refs.swiper ? this.$refs.swiper.swiper : false;
                }
                if (this.mySwiper) {
                    this.mySwiper.update();
                } else {
                    // failsafe for phonegap
                    setTimeout(() => {
                        if (!this.mySwiper) {
                            this.mySwiper = this.$refs.swiper ? this.$refs.swiper.swiper : false;
                        }
                        if (this.mySwiper) {
                            this.mySwiper.update();
                        }
                    }, 300);
                }
            }, 10);
        },
        isEligibleForGoal: function (topic) {
            return topic.type === 'goal' && topic.id !== 38 && utils.checkTraits(this.myTraits, topic);
        },
    }
};
</script>

<style lang="less" scoped>
@import '../../css/colors.less';

.center {
    text-align: center;
}
h2 {
    color: white;
    position: relative;
    z-index: 15;
    text-align: left;
    font-family: Editor-Bold;
    font-size: 21px;
    line-height: 26px;
    margin: 0 0 8px;
}
.blockTitle {
    margin-left: 0;
    color: white;
    font-family: AndesMedium;
    font-style: normal;
    font-weight: 300;
    font-size: 15px;
    line-height: 15px;
    z-index: 15;
    position: relative;
    margin-bottom: 4px;
}
.courseDescription {
    margin-top: -4px;
    color: white;
    font-family: AndesLight;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 14px;
    padding-bottom: 12px;
    z-index: 15;
    position: relative;
}
.moreLink {
    font-family: AndesMedium;
    text-transform: uppercase;
    line-height: 44px;
    color: #d9ccc4;
}
.nextLink {
    color: white;
    font-family: AndesMedium;
    text-transform: uppercase;
    line-height: 64px;
    z-index: 15px;
    position: relative;
    z-index: 16;
}
.home-scroll {
    margin-top: -100px !important;
    padding-top: 100px !important;
    height: ~'calc(100% + 100px)' !important;
    max-height: ~'calc(100% + 200px)' !important;
}
.homeBlockWrapper {
    text-align: left;
    transition: background-color 1s;
    color: white;
    background-size: 100% auto;
    background-position: bottom left;
    background-repeat: no-repeat;
    margin-bottom: 0px;
    padding-bottom: 20px;
}
</style>
